<template>
  <div class="header" id="topWarp">
    <div class="header-address" @click="changeAddress">
      <img v-if="localtionInfo.iconUrl" :src="localtionInfo.iconUrl | imageToHttps"/><i v-else></i> <span :style="{'color': localtionInfo.titleColor}">{{locationInfo.city}}</span>
    </div>
    <div class="header-search" @click="fnOpenSearch">
      <svg class="icon-svg" aria-hidden="true">
        <use :xlink:href="$globalIcon.searchIcon"></use>
      </svg>
      <div class="text">
        <textScroll :dataList="info.words"/>
      </div>
    </div>
  </div>
</template>

<script>
import textScroll from '@/components/textscroll/index.vue'

import { mapState } from 'vuex'
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    localtionInfo: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    textScroll
  },
  computed: {
    ...mapState({
      locationInfo: state => state.locationInfo,
    })
  },
  methods: {
    fnOpenSearch() {
      this.$router.push({
        path: '/goodsSearch',
      })
    },
    changeAddress(){
      this.$emit('changeAddress')
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  padding: 0 .32rem;
  height: .88rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 50;
}

.header-address{
  display: flex;
  align-items: center;
  font-size: .28rem;
  color: #333;
  i {
    display: inline-block;
    width: .36rem;
    height: .36rem;
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/location/icon_addr.png) no-repeat;
    background-size: contain;
  }
  img{
    display: inline-block;
    width: .36rem;
    height: .36rem;
  }
  span{
    margin-left: .1rem;
    max-width: 1.75rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.header-search{
  display: flex;
  align-items: center;
  width: 4rem;
  padding: 2px .3rem;
  border-radius: .5rem;
  background: rgba(255,255,255, .3);
}

.icon-svg{
  margin-right: .15rem;
  width: .25rem;
  height: .25rem;
}
</style>